import { Skeleton, Spin, Switch, Typography } from 'antd';
import { useChatAgentStatus } from 'hooks';
import { omniChatMessages } from 'messages';
import { useUpdateChatAgentStatusMutation } from 'services';
import { twMerge } from 'tailwind-merge';
import { CHAT_AGENT_STATUS } from 'utils';

type OmniChatSessionsStatusToggleProps = {};

const OmniChatSessionsStatusToggle: React.FC<OmniChatSessionsStatusToggleProps> = ({}) => {
  const { data, isLoading } = useChatAgentStatus();
  const [onChangeStatus, { isLoading: isLoadingChange }] = useUpdateChatAgentStatusMutation();

  const handleChangeStatus = (e: boolean) => {
    onChangeStatus({
      status: e ? CHAT_AGENT_STATUS.READY : CHAT_AGENT_STATUS.NOT_READY
    });
  };

  return (
    <div className={twMerge('flex items-center gap-1', (isLoading || isLoadingChange) && 'opacity-60')}>
      <Spin size='small' spinning={isLoading || isLoadingChange}>
        <div className='flex items-center gap-1'>
          <Typography.Text className='text-sm'>
            {data?.status === CHAT_AGENT_STATUS.READY ? omniChatMessages.ready : omniChatMessages.pause}
          </Typography.Text>
          <Switch
            checked={data?.status === CHAT_AGENT_STATUS.READY}
            onChange={(checked) => handleChangeStatus(checked)}
          />
        </div>
      </Spin>
    </div>
  );
};

export default OmniChatSessionsStatusToggle;
